import CreatePinPage from './CreatePinPage.vue'
import CreateAgainPinPage from './CreateAgainPinPage.vue'

export default [
  {
    path: 'register-success',
    name: 'RegisterSuccessPage',
    component: () => import('./RegisterSuccessPage.vue')
  },
  {
    path: 'pin-change-success',
    name: 'PinChangeSuccessPage',
    component: () => import('./PinChangeSuccessPage.vue')
  },
  {
    path: 'register',
    name: 'register',
    component: () => import('./RegisterPage.vue')
  },
  {
    path: 'register-new',
    name: 'register-new',
    component: () => import('./RegisterNewPage.vue')
  },
  {
    path: 'verify-whatsapp-code',
    name: 'VerifyWhatsappCode',
    component: () => import('./VerifyWhatsappCode.vue')
  },
  {
    path: 'create-pin',
    name: 'CreatePinPage',
    component: CreatePinPage
  },
  {
    path: 'create-again-pin',
    name: 'CreateAgainPinPage',
    component: CreateAgainPinPage
  }
]
